import { Home } from "../api";
import {
  showLoading,
  setQuotation,
} from "../actions";

export function getQuotation() {
  return function func(dispatch, getState) {

    const { quoter } = getState().options;
    const { 
      houseType,
      fireSelected, 
      theftSelected, 
    } = getState().home;

    const request = {
      zone: '1',
      broker: '',
      houseType: houseType === "H" ? "1" : "2",
      bFireCode: fireSelected.Code,
      theftCode: theftSelected.Code,
    };
    
    dispatch(showLoading(true));

    return Home.getQuotation(request).then(response => {
      if (response) {
        dispatch(setQuotation(quoter, response));
      } else {
        dispatch(setQuotation(quoter, { respuesta: { mensaje: 'Error al obtener la cotización' }}));
      }
      dispatch(showLoading(false));
    });
  };
}